/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_CloseInputs */

const en_us2_search_close = /** @type {(inputs: Search_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close search`)
};

const pt_br2_search_close = /** @type {(inputs: Search_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar busca`)
};

const es_419_search_close = /** @type {(inputs: Search_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar búsqueda`)
};

const pt_pt2_search_close = /** @type {(inputs: Search_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar pesquisa`)
};

const fr_fr2_search_close = /** @type {(inputs: Search_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la recherche`)
};

const de_de2_search_close = /** @type {(inputs: Search_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche schließen`)
};

const it_it2_search_close = /** @type {(inputs: Search_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi ricerca`)
};

/**
* | output |
* | --- |
* | "Close search" |
*
* @param {Search_CloseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_close = /** @type {((inputs?: Search_CloseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_CloseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_close(inputs)
	if (locale === "es-419") return es_419_search_close(inputs)
	if (locale === "pt-PT") return pt_pt2_search_close(inputs)
	if (locale === "fr-FR") return fr_fr2_search_close(inputs)
	if (locale === "de-DE") return de_de2_search_close(inputs)
	if (locale === "it-IT") return it_it2_search_close(inputs)
	return en_us2_search_close(inputs)
});
export { search_close as "search.close" }